export default __webpack_public_path__ + "static/Plain-ExtraboldItalic-32eba0c584c3669fe9830f683ee05c83.woff";